import { TOKEN_KEY, clearSession } from './session';

export const login = (token) => {
    if (typeof token !== 'string' || !token.trim() || token === 'undefined' || token === 'null') {
        throw new Error('No valid login token was received. Please sign in again.');
    }
    localStorage.setItem(TOKEN_KEY, token);
};

export const logout = async () => {
    try {
        const { customerApi } = await import('../api/Api');
        await customerApi.logout();
    } catch (error) {
        // Local logout still completes if the server is unavailable.
    } finally {
        clearSession();
        // Reload to clear customer-specific UI and in-memory caches.
        window.location.assign('/');
    }
};

export const isLogin = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return !!token && token !== 'undefined' && token !== 'null';
};
